import { get } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";
import { normalizarFecha } from "../utils/dateUtils";

export enum DiaSemana {
  Lunes = "Lunes",
  Martes = "Martes",
  Miercoles = "Miercoles",
  Jueves = "Jueves",
  Viernes = "Viernes",
  Sabado = "Sabado",
  Domingo = "Domingo",
}

export interface ItemListadoMascotasReservas {
  id: string;
  nombre: string;
  idPropietario: string;
  nombresPropietario: string;
  documentoPropietario: string;
  raza: string;
  fechasReservadas: Date[];
}

export const listarMascotasReservasGuarderia = async (): Promise<
  ItemListadoMascotasReservas[] | undefined
> => {
  const resp = await get<Array<ItemListadoMascotasReservas>>(
    "reservas/guarderia/mascotas"
  );
  return resp?.map((item) => {
    return {
      ...item,
      fechasReservadas: item.fechasReservadas.map((fecha) =>
        normalizarFecha(fecha)
      ),
    };
  });
};

const QUERY_LISTAR_MASCOTAS_RESERVAS_GUARDERIA =
  "QUERY_LISTAR_MASCOTAS_RESERVAS_GUARDERIA";

export const useListarMascotasReservasGuarderia = () => {
  return useQuery(
    [QUERY_LISTAR_MASCOTAS_RESERVAS_GUARDERIA],
    async () => await listarMascotasReservasGuarderia()
  );
};

